import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AssetUIModel, CommonUtilityLib } from '@thehubz/client/core';
import { Subscription, filter } from 'rxjs';
import { AssetCommonService } from '../../../services/asset-common.service';
import { AssetViewComponent } from '../asset-info/components/asset-view/asset-view.component';
import { AssetTaggingNTaxonomyMetadataComponent } from './asset-tagging-n-taxonomy-metadata/asset-tagging-n-taxonomy-metadata.component';

@Component({
  selector: 'thehubz-asset-tagging-n-taxonomy',
  templateUrl: './asset-tagging-n-taxonomy.component.html',
  styleUrls: ['./asset-tagging-n-taxonomy.component.scss'],
  standalone: true,
  imports: [CommonModule, AssetViewComponent, AssetTaggingNTaxonomyMetadataComponent],
})
export class AssetTaggingNTaxonomyComponent implements OnInit, OnDestroy {
  assetInfo!: AssetUIModel;
  assetDataSubjectSubscription: Subscription | undefined;

  sharingFlag = false;

  constructor(
    private assetCommonService: AssetCommonService,
    private activatedRoute: ActivatedRoute,
    private commonUtilityLib: CommonUtilityLib,
  ) {}

  ngOnInit(): void {
    this.sharingFlag = this.activatedRoute.snapshot.data['sharingFlag'];
    this.assetDataSubjectSubscription = this.assetCommonService.assetDataSubject$
      .pipe(filter((asset) => !this.commonUtilityLib.isEmptyObject(asset)))
      .subscribe((asset) => {
        if (asset) this.assetInfo = asset;
      });
  }
  ngOnDestroy(): void {
    if (this.assetDataSubjectSubscription) this.assetDataSubjectSubscription.unsubscribe();
  }
}
